import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentMethodsComponent } from './payment-methods.component';
import { ReactiveFormsModule } from '@angular/forms';
import { InputsGeneratorModule } from '../inputs-generator/inputs-generator.module';
import { DirectivesModule } from '../../directives/directives.module';
import { createCustomElement } from '@angular/elements';
import { UnzerComponent } from './method/unzer/unzer.component';
import { ElvComponent } from './method/elv/elv.component';
import { UmsbankingComponent } from './method/umsbanking/umsbanking.component';
import { DialogModule } from 'primeng/dialog';
import { FormUtilitiesModule } from '../../ds24-ui/form-utilities';
import { StripeComponent } from './method/stripe/stripe.component';
import { HeidelpayCcComponent } from './method/heidelpay-cc/heidelpay-cc.component';
import { BraintreeComponent } from './method/braintree/braintree.component';
import { KlarnaComponent } from './method/klarna/klarna.component';
import { CvcDialogComponent } from './cvc-dialog/cvc-dialog.component';
import { VenmoComponent } from './method/venmo/venmo.component';
import { SanitizePipeModule } from '@digistore/ds24-ui/pipes';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    PaymentMethodsComponent,
    UnzerComponent,
    ElvComponent,
    UmsbankingComponent,
    StripeComponent,
    HeidelpayCcComponent,
    BraintreeComponent,
    CvcDialogComponent,
    VenmoComponent,
    KlarnaComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputsGeneratorModule,
    DirectivesModule,
    PipesModule,
    SanitizePipeModule,
    DialogModule,
    FormUtilitiesModule,
  ],
})
export class PaymentMethodsModule {
  static initialize(injector: Injector) {
    const customComponent = createCustomElement(PaymentMethodsComponent, {
      injector: injector,
    });
    customElements.define('ds-orderform-payment-methods', customComponent);
  }
}
